import {connect} from 'react-redux'
import {Header} from 'report-components'
import {updateReportSettings} from 'report-components/lib/reducers'
import {getResource} from '../lib'
import {postFetcher} from 'startlibs'

const uploadFetcher = (formData) => postFetcher('/api/upload-logo', formData)

export const ReportHeader = connect(
  ({report}) => ({
    reportSettings: report.reportSettings,
    action: updateReportSettings,
    getResource: getResource,
    uploadFetcher
  })
)(Header)





// WEBPACK FOOTER //
// ./src/javascripts/report/ReportHeader.jsx